module.exports = __webpack_public_path__ + "static/media/share-post-icon.f49f20bf.svg";